export const translations = {
  ro: {
    nav: {
      about: "Despre",
      services: "Servicii",
      tools: "Echipament",
      cases: "Studii de caz",
      gallery: "Cartografie",
      faq: "Întrebări",
      contact: "Contact",
      cta: "Solicită consultanță",
      language: "Limbă",
    },
    tools: {
      overline: "ECHIPAMENT & SOFTWARE",
      title: "Tehnologie de standard internațional.",
      subtitle:
        "Instrumente profesionale ce stau la baza fiecărei expertize tehnice — de la reconstituire 3D la citirea datelor EDR.",
    },
    cases: {
      overline: "STUDII DE CAZ",
      title: "Cazuri rezolvate. Probă tehnică livrată.",
      subtitle:
        "Selecție de expertize realizate, anonimizate pentru confidențialitate. Fiecare caz este abordat cu aceeași rigoare metodologică.",
    },
    faq: {
      overline: "ÎNTREBĂRI FRECVENTE",
      title: "Răspunsuri scurte la întrebări esențiale.",
      subtitle:
        "Cele mai uzuale întrebări primite de la clienți. Pentru orice altă lămurire, contactați-mă direct.",
    },
    hero: {
      overline: "EXPERT TEHNIC JUDICIAR · AUTORIZAT MJ",
      title_l1: "Expertize tehnice",
      title_l2: "în domeniul",
      title_l3: "auto și rutier.",
      subtitle:
        "Reconstituire accident, evaluări de piață și cartografiere aeriană a sectorului rutier cu drone DJI. Probă tehnică precisă pentru instanțe, asigurători și clienți privați.",
      cta_primary: "Solicită expertiză",
      cta_secondary: "Vezi servicii",
      meta_auth: "Autorizație Nr.",
      meta_series: "Seria",
      meta_specialty: "Specialitate · Autovehicule & circulație rutieră",
    },
    about: {
      overline: "DESPRE EXPERT",
      title: "Lontis Nicolae Stelian",
      role: "Expert Tehnic Judiciar",
      paragraph_1:
        "Activez în domeniul expertizei tehnice judiciare și extrajudiciare pe segmentul „Autovehicule și circulație rutieră”, oferind analiză tehnică detaliată a evenimentelor rutiere, dinamicii coliziunilor și a stării vehiculelor implicate.",
      paragraph_2:
        "Lucrez cu instanțe, avocați, societăți de asigurare și clienți privați. Fiecare raport este construit pe măsurători obiective, fotogrammetrie și, atunci când este necesar, cartografiere aeriană efectuată cu drona DJI Mavic Pro 2.",
      stat_1_label: "Specializare",
      stat_1_value: "Auto & rutier",
      stat_2_label: "Autorizație",
      stat_2_value: "Nr. 3710072019",
      stat_3_label: "Echipament",
      stat_3_value: "DJI Mavic Pro 2",
    },
    services: {
      overline: "SERVICII",
      title: "Trei direcții. O singură rigoare tehnică.",
      subtitle:
        "Servicii dedicate evenimentelor rutiere — de la cabinet de expertiză la teren și până la raportul final.",
      items: [
        {
          id: "expertize",
          tag: "01",
          title: "Expertize tehnice judiciare și extrajudiciare",
          desc: "Rapoarte tehnice pentru instanțe, parchet, asigurători și clienți privați. Reconstituire accident, dinamica coliziunii, cauze și împrejurări.",
          bullets: [
            "Reconstituire dinamică",
            "Analiză cauze",
            "Suport în instanță",
          ],
        },
        {
          id: "evaluare",
          tag: "02",
          title: "Evaluarea de piață a vehiculelor",
          desc: "Evaluare obiectivă a valorii de piață ante și post eveniment rutier, pentru daune totale, despăgubiri și litigii cu asigurătorul.",
          bullets: [
            "Valoare ante-eveniment",
            "Valoare post-eveniment",
            "Daună totală",
          ],
        },
        {
          id: "cartografie",
          tag: "03",
          title: "Cartografiere aeriană cu drona DJI Mavic Pro 2",
          desc: "Cartografiere foto/video a sectorului de drum unde s-a produs evenimentul rutier. Ortofotoplan, măsurători și plan de situație.",
          bullets: [
            "Ortofotoplan",
            "Măsurători la teren",
            "Plan de situație",
          ],
        },
      ],
    },
    gallery: {
      overline: "CARTOGRAFIE & TEREN",
      title: "Probă vizuală. Captată din aer.",
      subtitle:
        "Selecție de imagini și capturi realizate cu drona DJI Mavic Pro 2 în cadrul expertizelor tehnice.",
      tags: ["Ortofoto", "Profil drum", "Trafic", "Cartografie", "Detaliu"],
    },
    contact: {
      overline: "CONTACT",
      title: "Discutăm cazul dumneavoastră.",
      subtitle:
        "Trimiteți o cerere de expertiză sau solicitați o estimare. Vă răspund în cel mai scurt timp posibil.",
      info_title: "Date de contact",
      phone: "Telefon",
      email: "Email",
      address: "Adresă",
      hours: "Program",
      hours_value: "Luni–Vineri · 09:00–18:00",
      form: {
        name: "Nume complet",
        email: "Email",
        phone: "Telefon (opțional)",
        service: "Tip serviciu",
        subject: "Subiect",
        message: "Detalii caz",
        submit: "Trimite cererea",
        submitting: "Se trimite...",
        success: "Mulțumesc. Cererea a fost înregistrată.",
        error: "A apărut o eroare. Încercați din nou.",
        select_service: "Selectați un serviciu",
        gdpr_consent: "Sunt de acord cu prelucrarea datelor mele personale conform Politicii de confidențialitate.",
        gdpr_required: "Este obligatoriu să acceptați politica de confidențialitate pentru a trimite cererea.",
        gdpr_note: "Datele dvs. sunt prelucrate exclusiv pentru a răspunde acestei solicitări și nu sunt transmise terților. Conform GDPR, aveți drepturile de acces, rectificare și ștergere — vedeți",
        services: [
          "Expertiză tehnică judiciară",
          "Expertiză extrajudiciară",
          "Evaluare de piață vehicul",
          "Cartografiere cu drona",
          "Altele",
        ],
      },
    },
    footer: {
      tagline: "Expertiză tehnică pentru evenimente rutiere.",
      rights: "Toate drepturile rezervate.",
      auth: "Autorizație Nr. 3710072019 · Seria 74788314062019",
      privacy: "Politică de confidențialitate",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      tools: "Equipment",
      cases: "Case studies",
      gallery: "Cartography",
      faq: "FAQ",
      contact: "Contact",
      cta: "Request consultation",
      language: "Language",
    },
    tools: {
      overline: "EQUIPMENT & SOFTWARE",
      title: "International-standard technology.",
      subtitle:
        "Professional instruments behind every technical expertise — from 3D reconstruction to EDR data retrieval.",
    },
    cases: {
      overline: "CASE STUDIES",
      title: "Cases resolved. Technical evidence delivered.",
      subtitle:
        "A selection of completed expertises, anonymized for confidentiality. Each case is approached with the same methodological rigor.",
    },
    faq: {
      overline: "FREQUENTLY ASKED",
      title: "Short answers to essential questions.",
      subtitle:
        "The most common questions from clients. For any further clarification, please get in touch directly.",
    },
    hero: {
      overline: "TECHNICAL JUDICIAL EXPERT · MoJ AUTHORIZED",
      title_l1: "Technical expertise",
      title_l2: "for road traffic",
      title_l3: "and vehicles.",
      subtitle:
        "Accident reconstruction, market valuations and aerial cartography of road sectors with DJI drones. Precise technical evidence for courts, insurers and private clients.",
      cta_primary: "Request expertise",
      cta_secondary: "See services",
      meta_auth: "Authorization No.",
      meta_series: "Series",
      meta_specialty: "Specialty · Vehicles & road traffic",
    },
    about: {
      overline: "ABOUT THE EXPERT",
      title: "Lontis Nicolae Stelian",
      role: "Technical Judicial Expert",
      paragraph_1:
        "I operate in judicial and extrajudicial technical expertise within the field of “Vehicles and road traffic”, delivering detailed technical analysis of road events, collision dynamics and the condition of the vehicles involved.",
      paragraph_2:
        "I work with courts, attorneys, insurance companies and private clients. Each report is built on objective measurements, photogrammetry and, when needed, aerial cartography performed with a DJI Mavic Pro 2 drone.",
      stat_1_label: "Specialty",
      stat_1_value: "Auto & traffic",
      stat_2_label: "Authorization",
      stat_2_value: "No. 3710072019",
      stat_3_label: "Equipment",
      stat_3_value: "DJI Mavic Pro 2",
    },
    services: {
      overline: "SERVICES",
      title: "Three directions. One technical rigor.",
      subtitle:
        "Services dedicated to road events — from the expert's office to on-site work and the final report.",
      items: [
        {
          id: "expertize",
          tag: "01",
          title: "Judicial & extrajudicial technical expertise",
          desc: "Technical reports for courts, prosecutors, insurers and private clients. Accident reconstruction, collision dynamics, causes and circumstances.",
          bullets: [
            "Dynamic reconstruction",
            "Cause analysis",
            "Court support",
          ],
        },
        {
          id: "evaluare",
          tag: "02",
          title: "Market valuation of vehicles",
          desc: "Objective valuation of the market value before and after a road event — total losses, claims and disputes with insurers.",
          bullets: [
            "Pre-event value",
            "Post-event value",
            "Total loss",
          ],
        },
        {
          id: "cartografie",
          tag: "03",
          title: "Aerial cartography with DJI Mavic Pro 2",
          desc: "Photo/video cartography of the road sector where the event occurred. Orthophoto, measurements and situation plan.",
          bullets: ["Orthophoto", "Field measurements", "Site plan"],
        },
      ],
    },
    gallery: {
      overline: "CARTOGRAPHY & FIELD",
      title: "Visual evidence. Captured from above.",
      subtitle:
        "A selection of imagery captured with the DJI Mavic Pro 2 drone during technical expertise work.",
      tags: ["Orthophoto", "Road profile", "Traffic", "Cartography", "Detail"],
    },
    contact: {
      overline: "CONTACT",
      title: "Let's discuss your case.",
      subtitle:
        "Send an expertise request or ask for an estimate. I reply as quickly as possible.",
      info_title: "Contact details",
      phone: "Phone",
      email: "Email",
      address: "Address",
      hours: "Hours",
      hours_value: "Mon–Fri · 09:00–18:00",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        service: "Service type",
        subject: "Subject",
        message: "Case details",
        submit: "Send request",
        submitting: "Sending...",
        success: "Thank you. Your request has been registered.",
        error: "Something went wrong. Please try again.",
        select_service: "Select a service",
        gdpr_consent: "I agree to the processing of my personal data according to the Privacy Policy.",
        gdpr_required: "You must accept the privacy policy in order to send the request.",
        gdpr_note: "Your data is processed solely to respond to this request and is not shared with third parties. Under GDPR you have rights of access, rectification and erasure — see",
        services: [
          "Judicial technical expertise",
          "Extrajudicial expertise",
          "Vehicle market valuation",
          "Drone cartography",
          "Other",
        ],
      },
    },
    footer: {
      tagline: "Technical expertise for road events.",
      rights: "All rights reserved.",
      auth: "Authorization No. 3710072019 · Series 74788314062019",
      privacy: "Privacy Policy",
    },
  },
};
